var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('div',{ref:"editor",staticStyle:{"height":"200px","max-height":"200px"},attrs:{"id":"div1"}})])}
var staticRenderFns = []

export { render, staticRenderFns }